import { api } from "roboflex-thalamus-request-handler";

export default {
  async listar(page = 1, perPage = 25, filters = {}) {
    const params = { page, per_page: perPage };

    if (filters.op != null && String(filters.op).trim() !== "") {
      params.op = String(filters.op).trim();
    }
    if (filters.op_cod != null) params.op_cod = filters.op_cod;
    if (filters.maquina_id != null) params.maquina_id = filters.maquina_id;
    if (filters.status != null && filters.status !== "") params.status = filters.status;
    if (filters.dt_inicio != null && filters.dt_inicio !== "") params.dt_inicio = filters.dt_inicio;
    if (filters.dt_fim != null && filters.dt_fim !== "") params.dt_fim = filters.dt_fim;

    const response = await api.get("injecao/primeira-peca/listar", { params });
    const data = response.data;

    return {
      data: data.data || [],
      pagination: {
        currentPage: data.current_page,
        lastPage: data.last_page,
        perPage: data.per_page,
        total: data.total,
        from: data.from,
        to: data.to,
      },
    };
  },
};
